import React, { useEffect } from 'react'
import Navbar from '../common/Navbar'
import ServiceWapp from '../components/service/ServiceWapp'
import Footer from '../common/Footer'
import { useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet'

const ServiceWappContent = () => {
  const location = useLocation();
  useEffect(() => {
    const { search } = location;
    if (!search) {
      window.scroll(0, 0);
    }
  }, []);
  return (
    <>
    <Helmet>
      <meta name="keywords" content="rich communication service message,rcs sms in Chennai,rich message service in Chennai,rcs rich communication service,rich communication message,rich sms messages in Chennai,rcs sms in india,rich message service in india "/> 
    </Helmet>
        <div>
      <Navbar/>
      <ServiceWapp/>
      <Footer/>
    </div></>

  )
}

export default ServiceWappContent
